var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subgroup && _vm.subgroup._id)?_c('IconBtn',{attrs:{"color":"error","loading":_vm.loading,"icon":"mdi-delete","title":"Remove"},on:{"click":function($event){$event.preventDefault();return _vm.handleRemove()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }